import { SegmentEvent } from '@/integrations/segment/SegmentEvent';
import { PaywallPaymentModalViewedEventTracking } from '@/modules/auth/models/segmentevents/PaywallPaymentModalViewedEventTracking';

export class PaywallPaymentModalQuitEventTracking extends PaywallPaymentModalViewedEventTracking {
  static eventName: SegmentEvent = SegmentEvent.PAYWALL_PAYMENT_MODAL_QUIT;
}
